import React, { useEffect, useState } from "react";
import { Modal, Button, Container, Card, Col, Row } from "react-bootstrap";
import FormCard from "../common/formCard";
import { FaTimes } from "react-icons/fa";
import { useTranslation } from 'react-i18next';


const PopUpFeedback = ({ show, handleClose, onClickButton, data }) => {
  const [t] = useTranslation("publicIncident")


  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Body className="width-75-vw">
          <Container>
            <Card className="mx-auto p-3 rounded-border-px custom-shadow">
              <Card.Body className="d-flex flex-column align-items-center">
                <p className="modal-title mt-2"></p>
                <div className="text-center mt-auto w-100">
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={handleClose}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <Row>

                    <Col md={5}>
                      <FormCard
                        title={t("createForm.name")}
                        text={data ? data.username : '---'}
                        type={"textarea"}
                        readOnly
                      />
                    </Col>
                    <Col md={7}>
                      <FormCard
                        title={t("createForm.title")}
                        text={data ? data.title : '---'}
                        type={"textarea"}

                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} >
                      <FormCard
                        title={t("createForm.description")}
                        text={data ? data.description : '---'}
                        type={"textarea"}
                        readOnly
                      />
                    </Col>
                  </Row>

                  <Button
                    type="submit"
                    className="w-25 mx-auto mt-4 custom-button-primary custom-bg-primary"
                    onClick={handleClose}

                  >
                    {t("messagesPopUp.button")}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopUpFeedback;